module.exports = __webpack_public_path__ + "static/media/Arthur Weasley 2.deadf124.jpg";